import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import FileViewer from "react-file-viewer";
import FileViewerError from "../../FileViewer/FileViewerError";

const AddAttachment = ({
  setShowAddAttachment,
  setAttachmentFile,
  attachmentFile,
  setAttachmentDataFile,
  attachmentDataFile,
  setAttachments,
  attachments,
  setFiles,
  files,
}) => {
  const [docType, setDocType] = useState("docx");
  const [attachmentArrayFile, setAttachmentArrayFile] = useState("");

  return (
    <Fragment>
      <div className="resume-overlay">
        <div className="document-box">
          <i
            className="fas fa-times fa-3x profile-x"
            onClick={() => setShowAddAttachment(false)}
          ></i>
          <div className="width-container">
            {attachmentFile.file !== "" ? (
              <p className="attachment-name-alt">
                <i className="far fa-folder fa-lg mr-10 red"></i>
                {attachmentFile.file}
              </p>
            ) : (
              <div className="flex-center">
                <p className="attachment-name-alt">
                  <i className="far fa-folder fa-lg mr-10 red"></i>Attachment
                  Name
                </p>
              </div>
            )}
            <div className="input-label-container">
              <label htmlFor="firstname" className="labels-input red bold">
                *File Type:
              </label>
              <select
                className="jobs-select"
                name="fileType"
                onChange={(e) => setDocType(e.target.value)}
              >
                <option value="docx">docx</option>
                <option value="pdf">pdf</option>
                <option value="csv">csv</option>
                <option value="xslx">xslx</option>
              </select>
            </div>
            <div className="items-container-attachment">
              <div className="sub-section-container-alt">
                <div className="flex-only">
                  <p className="sub-section red">Attachment Description</p>
                </div>
                <div className="input-label-container">
                  <label
                    htmlFor="coursetitle"
                    className="labels-input bold red"
                  >
                    *Attachment Description:
                  </label>
                  <input
                    type="text"
                    name="coursetitle"
                    value={attachmentFile.description}
                    className="input-item"
                    placeholder="Enter attachment description"
                    onChange={(e) =>
                      setAttachmentFile({
                        ...attachmentFile,
                        description: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="upload-container">
              {attachmentDataFile === "" ? (
                <label
                  htmlFor="profilephotopost"
                  className="setup-image-container"
                >
                  <div className="create-attachment-icons red">
                    <i className="fas fa-plus fa-lg red"></i>
                    <i className="far fa-folder fa-4x mx-5 red"></i>
                  </div>
                </label>
              ) : (
                <div className="document">
                  <FileViewer
                    fileType={docType}
                    filePath={attachmentDataFile}
                    errorComponent={FileViewerError}
                    onError={FileViewerError}
                  />
                </div>
              )}
              <input
                type="file"
                name="profilephotopost"
                id="profilephotopost"
                className="file-upload"
                onChange={(e) => {
                  setAttachmentFile({
                    ...attachmentFile,
                    file: e.target.files[0].name,
                  });
                  setAttachmentDataFile(URL.createObjectURL(e.target.files[0]));
                  setAttachmentArrayFile(e.target.files[0]);
                }}
              />
            </div>
            {attachmentDataFile !== "" && (
              <div
                className="create-post-button-container"
                onClick={() => {
                  setAttachmentFile({ file: "", description: "" });
                  setAttachmentDataFile("");
                }}
              >
                <button
                  type="submit"
                  className="create-post-button background-red"
                >
                  <i className="fas fa-times mx-5"></i>Delete Attachment
                </button>
              </div>
            )}
          </div>
        </div>
        {attachmentDataFile !== "" && attachmentFile.description !== "" && (
          <div
            className="submit-changes"
            onClick={() => {
              setAttachments([...attachments, attachmentFile]);
              setFiles([...files, attachmentArrayFile]);
              setAttachmentDataFile("");
              setAttachmentFile({ file: "", description: "" });
              setShowAddAttachment(false);
            }}
          >
            <button className="submit-changes-button background-red">
              Add Attachment
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

AddAttachment.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AddAttachment);
